import React, { Component } from 'react';
import classnames from 'classnames';

class RedirectableRequestOuter extends Component {

  static defaultProps = {
    requestText : "Loading...",
    isPublic : null,
    previousID : null,
    isLast : false,
  }

  state = {
    isHover : false,
  };

  handleRedirectOnClick = (e) => {
    

    e.stopPropagation();
  }

  handleRedirectBtnOnClick = (e) => {
    const { updateID } = this.props;
    const { updateResponseRedirect } = this.props;
    

    updateResponseRedirect(updateID);

    e.stopPropagation();
  }

  handleOnMouseEnter = (e) => {
    this.setState({
      isHover : true,
    })
    e.stopPropagation();
  }
  
  handleOnMouseLeave = (e) => {
    this.setState({
      isHover : false,
    })
    e.stopPropagation();
  }

  render() { 
    const { props } = this;
    const { handleOnMouseEnter } = this;
    const { handleOnMouseLeave } = this;
    const { handleRedirectBtnOnClick } = this;
    const { handleRedirectOnClick } = this;
    const { requestText } = props;
    const { isLast } = props;

    const { isHover } = this.state;

    const requestClassNames = classnames({
      'redirectable-request-outer' : true,
      'last-request' : isLast,
    });

    const redirectBtnClassNames = classnames({
      btn : true,
      'btn-primary' : true,
      'redirect-select-btn' : true,
      'hide' : !isHover,
    });

    return (
      <li className={requestClassNames}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
        onClick={handleRedirectOnClick}>
        <p className="req-title">
          {requestText}
        </p>
        <button className={redirectBtnClassNames}
          onClick={handleRedirectBtnOnClick} >
          지정
        </button>
      </li>
    );
  }
}
 
export default RedirectableRequestOuter;